import { SVGProps } from "react";

export default function HorizontalLineIcon(props: SVGProps<SVGSVGElement>) {
  const { height = 2, width = 25, stroke = "black", ...rest } = props;

  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 25 2"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M0 1H24.2695"
        stroke={stroke}
        strokeWidth="2"
      />
    </svg>
  );
}